module.exports = __webpack_public_path__ + "img/correct.39ac8938.svg";